import { TopBarNav } from '../TopBarNav';
import { Routes } from '../../enums/Routes.ts';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export const OrgOverviewTopBar = (): ReactElement => {
  const { t } = useTranslation();
  const routesToRender = [
    {
      link: Routes.OrganizationSettings,
      label: t('teams.navigation.settings'),
    },
    {
      link: Routes.OrganizationUsersOverviewPage,
      label: t('teams.navigation.users'),
    },
    {
      link: Routes.OrganizationSubscriptions,
      label: t('teams.navigation.subscription'),
    },
    {
      link: Routes.OrganizationUsage,
      label: t('teams.navigation.usage'),
    },
  ];
  return <TopBarNav items={routesToRender} />;
};
